'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002416 from "./presto.-Presto$$anon$16.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00242 from "./presto.-Presto$$anon$2.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$1() {
  this.b9K = null;
  this.b9C = null;
  this.b9D = false;
  this.b9L = null;
  this.b9M = false;
  this.b9P = null;
  this.b9I = null;
  this.b9J = false;
  this.b9E = null;
  this.b9F = false;
  this.b9G = null;
  this.b9H = false;
  this.b9N = false;
  this.b9O = false;
  this.b9K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b9P = "SingleAppToken";
}
export { $c_Lpresto_Presto$$anon$1 as $c_Lpresto_Presto$$anon$1 };
$p = $c_Lpresto_Presto$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$1;
/** @constructor */
function $h_Lpresto_Presto$$anon$1() {
}
export { $h_Lpresto_Presto$$anon$1 as $h_Lpresto_Presto$$anon$1 };
$h_Lpresto_Presto$$anon$1.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b9K;
});
$p.M = (function() {
  if ((!this.b9D)) {
    this.b9C = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b9D = true;
  }
  return this.b9C;
});
$p.O = (function() {
  if ((!this.b9M)) {
    this.b9L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b9M = true;
  }
  return this.b9L;
});
$p.E = (function() {
  return this.b9P;
});
$p.t = (function() {
  if ((!this.b9J)) {
    this.b9I = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b9J = true;
  }
  return this.b9I;
});
$p.N = (function() {
  if ((!this.b9F)) {
    this.b9E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00242.$c_Lpresto_Presto$$anon$2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.b9F = true;
  }
  return this.b9E;
});
$p.Q = (function() {
  if ((!this.b9H)) {
    this.b9G = new $j_presto$002e$002dPresto$0024$0024anon$002416.$c_Lpresto_Presto$$anon$16();
    this.b9H = true;
  }
  return this.b9G;
});
$p.v = (function() {
  if ((!this.b9O)) {
    this.b9N = false;
    this.b9O = true;
  }
  return this.b9N;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee99) => ((p) => \u03b4scrutinee99.acZ(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_Presto$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$1, "presto.Presto$$anon$1", ({
  Ne: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$1 as $d_Lpresto_Presto$$anon$1 };
//# sourceMappingURL=presto.-Presto$$anon$1.js.map
